import { useState } from 'react';
import { Typography, Button, Dialog } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Trans, useTranslation } from 'react-i18next';
import numeral from 'numeral';

import useLockedScreen from 'lib/hooks/useLockedScreen';

export interface VehicleNotFoundDialogProps {
  listingsCount: number;
  isInitiallyShown?: boolean;
}

export default function VehicleNotFoundDialog(props: VehicleNotFoundDialogProps): JSX.Element {
  const [isShown, setIsShown] = useState(!!props.isInitiallyShown);
  const close = (): void => setIsShown(false);
  const classes = useVehicleNotFoundDialogStyles();
  const { t } = useTranslation();
  useLockedScreen(isShown);

  return (
    <Dialog open={isShown} onClose={close}>
      <div className={classes.content}>
        <Typography className={classes.primaryMessage}>
          {t('srp.vehicleNotFound.primaryMessage')}
        </Typography>

        {props.listingsCount > 0 && (
          <Typography className={classes.secondaryMessage}>
            <Trans
              i18nKey="srp.vehicleNotFound.secondaryMessage"
              values={{ listingsCount: numeral(props.listingsCount).format('0,0') }}
              components={[<span className={classes.listingsCount} />]}
            />
          </Typography>
        )}
        <Button
          fullWidth
          variant="contained"
          onClick={close}
          color="primary"
          className={classes.button}
          disableElevation
        >
          {t('srp.vehicleNotFound.confirm')}
        </Button>
      </div>
    </Dialog>
  );
}

const useVehicleNotFoundDialogStyles = makeStyles(() => ({
  content: {
    width: 280,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  primaryMessage: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 700,
    marginBottom: 12,
    width: 232,
    padding: '0 6px',
  },
  secondaryMessage: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 36,
    width: 232,
    padding: '0 6px',
  },
  listingsCount: {
    fontWeight: 'bold',
  },
  button: {
    height: 44,
    fontSize: 16,
    fontWeight: 600,
  },
}));
